import React, { memo, useCallback, useEffect, useMemo } from "react";
import { Map, Marker, useMap } from "@vis.gl/react-google-maps";

const DEFAULT_HEIGHT = "40vh";
export const DEFAULT_ZOOM = 8;
// REP. DOMINICANA
export const DEFAULT_LAT = 18.89297568835356;
export const DEFAULT_LNG = -70.39297462500001;

// Límite geográfico de República Dominicana (aprox)
const DOMINICAN_BOUNDS = {
  north: 19.94,
  south: 17.36,
  west: -72.01,
  east: -68.32
};

type TGestureHandling = "cooperative" | "greedy" | "none" | "auto";

interface MxMapViewerProps {
  height?: string;
  zoom?: number;
  disabled?: boolean;
  lat?: number;
  lng?: number;
  onDragEnd?: (e: any, map: any) => void;
  onClick?: (e: any, map: any) => void;
  showControls?: boolean;
  gestureHandling?: TGestureHandling;
}

const MxMapViewer: React.FC<MxMapViewerProps> = props => {
  const {
    height = DEFAULT_HEIGHT,
    disabled,
    lat,
    lng,
    zoom = DEFAULT_ZOOM,
    onDragEnd,
    onClick,
    showControls = true,
    // Keep default behavior unless explicitly overridden by parent
    gestureHandling = "cooperative"
  } = props;
  const map = useMap("map");

  const mapStyle = useMemo(
    () => ({
      width: "100%",
      height,
      borderRadius: 8,
      overflow: "hidden"
    }),
    [height]
  );

  const markerPosition = useMemo(
    () => ({
      lat: Number(lat) || DEFAULT_LAT,
      lng: Number(lng) || DEFAULT_LNG
    }),
    [lat, lng]
  );

  // Effect to handle position and zoom changes
  useEffect(() => {
    if (map && markerPosition) {
      map.panTo({ ...markerPosition });
      if (zoom !== DEFAULT_ZOOM) {
        map.setZoom(zoom);
      }
    }
  }, [map, markerPosition, zoom]);

  return (
    <Map
      id="map"
      style={mapStyle}
      defaultCenter={markerPosition}
      defaultZoom={zoom}
      gestureHandling={gestureHandling}
      disableDefaultUI={!showControls}
      onClick={e => onClick && onClick(e, map)}
    >
      <Marker
        position={markerPosition}
        draggable={!disabled}
        onDragEnd={e => onDragEnd && onDragEnd(e, map)}
      />
    </Map>
  );
};

export default memo(MxMapViewer);
